import { module } from 'modujs';
import { html } from '../utils/environment'

const CLASS = {
    OPEN: `has-widget-user-open`,
}

export default class extends module {
    constructor(m) {
        super(m);
        this.events = {
            click: {
                button: 'toggleWidget',
                inner: 'toggleWidget',
                close: 'close'
            }
        }
    }

    init(){
        this.isOpen = false

        // BANNER CODE
        // const date = new Date();
        // const startDate = new Date('Jul 22 2022 21:00:00 GMT-0400')
        // const endDate = new Date('Jul 24 2022 02:00:00 GMT-0400')
        // if(date > startDate && date < endDate) {
        //     this.addBanner(html.getAttribute('lang') == 'en' ? 'On July 23rd, 2022, our employees are on strike for 24 hours. Only essential services are offered to the public' : 'Le 23 juillet 2022, nos salariées sont en grève pendant une durée de 24 heures. Seuls les services essentiels sont offerts à la population');
        // }
    }

    toggleWidget(e) {

        if(e && !e.target.closest('[data-widget-user="button"]') && e.target.closest('a, button')) {
            return;
        }

        if(!html.classList.contains('has-widget-open') && !html.classList.contains('-footer')) {
            if(this.isOpen) {
                this.close()
            } else {
                this.open()
            }
        }
    }

    open() {
        this.isOpen = true

        html.classList.add(CLASS.OPEN)
    }

    close() {
        this.isOpen = false

        html.classList.remove(CLASS.OPEN)
    }

    addBanner(message) {
        const banner = document.createElement('div');
        banner.classList.add('c-widget-user_banner');
        banner.innerHTML = `
            <svg role="img">
                <use xlink:href="assets/images/sprite.svg#info"></use>
            </svg>
            <p></p>
        `

        const paragraph = banner.querySelector('p')
        paragraph.innerText = message;

        this.$('inner')[0].appendChild(banner)
    }
}
